import api from './api';

export interface StyleMatcherSession {
  id: string;
  startedAt: string;
  completedAt: string | null;
  totalSwipes: number;
  likesCount: number;
  passesCount: number;
  skipsCount: number;
  isActive: boolean;
}

export interface SwipeAction {
  dressId: string;
  action: 'like' | 'pass' | 'skip';
}

export interface StyleMatcherResults {
  totalSwipes: number;
  likes: number;
  passes: number;
  skips: number;
  categoryPreferences: Record<string, number>;
  recommendedDresses: any[]; // You can define a proper Dress type if needed
  sessionId: string;
}

export const styleMatcherService = {
  // Get all sessions for a customer
  async getCustomerSessions(customerId: string): Promise<StyleMatcherSession[]> {
    const response = await api.get(`/style-matcher/sessions/${customerId}`);
    return response.data.data;
  },

  // Get results for a specific session or latest session
  async getSessionResults(customerId: string, sessionId?: string): Promise<StyleMatcherResults> {
    const params = sessionId ? { sessionId } : {};
    // Using the customer endpoint to get their own results
    const response = await api.get(`/style-matcher/results`, { params });
    return response.data.data;
  },

  // Get swipe history for a session (we'll need to add this endpoint to the backend)
  async getSessionSwipes(sessionId: string): Promise<any[]> {
    // This endpoint doesn't exist yet in the backend, but we'll add it
    const response = await api.get(`/style-matcher/sessions/${sessionId}/swipes`);
    return response.data.data;
  },

  // Get analytics for style matcher usage
  async getAnalytics(): Promise<any> {
    // This endpoint will need to be created for staff to see overall analytics
    const response = await api.get('/style-matcher/analytics');
    return response.data.data;
  }
};